<template>
  <!-- Timeline Layout dengan Garis Vertikal -->
  <div class="relative" ref="timelineContainer">
    <!-- Garis vertikal tengah (desktop) -->
    <div
      class="hidden md:block absolute left-1/2 top-0 bottom-0 w-1 bg-gradient-to-b from-primary via-accent to-primary transform -translate-x-1/2 rounded-full"
    ></div>

    <!-- Animated Progress Line (desktop) -->
    <div
      class="hidden md:block absolute left-1/2 top-0 w-1 bg-gradient-to-b from-blue-500 to-blue-300 transform -translate-x-1/2 rounded-full transition-all duration-100 ease-linear shadow-lg"
      :style="{ height: scrollProgress + '%' }"
    ></div>

    <!-- Garis vertikal kiri (mobile) -->
    <div
      class="md:hidden absolute left-6 top-0 bottom-0 w-1 bg-gradient-to-b from-primary via-accent to-primary rounded-full"
    ></div>

    <!-- Animated Progress Line (mobile) -->
    <div
      class="md:hidden absolute left-6 top-0 w-1 bg-gradient-to-b from-blue-500 to-blue-300 rounded-full transition-all duration-100 ease-linear shadow-lg"
      :style="{ height: scrollProgress + '%' }"
    ></div>

    <!-- Timeline Items -->
    <div class="space-y-16 md:space-y-20">
      <!-- Hari Pertama (Kiri) -->
      <div class="relative flex items-center">
        <!-- Dot di tengah (desktop) -->
        <div
          class="hidden md:block absolute left-1/2 w-6 h-6 bg-white border-4 border-primary rounded-full transform -translate-x-1/2 z-10 shadow-lg"
        ></div>

        <!-- Dot di kiri (mobile) -->
        <div
          class="md:hidden absolute left-[26px] w-6 h-6 bg-white border-4 border-primary rounded-full transform -translate-x-1/2 z-10 shadow-lg"
        ></div>

        <!-- Card Content -->
        <div
          class="w-full md:w-5/12 ml-12 md:ml-0 bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
          data-aos="fade-right"
          data-aos-anchor-placement="top-bottom"
          data-aos-delay="100"
        >
          <div
            class="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4 border-b border-gray-100 pb-3"
          >
            <h3 class="text-xl sm:text-2xl font-bold text-primary mb-2 sm:mb-0">
              Hari Pertama
            </h3>
            <div
              class="flex flex-col sm:flex-row items-start sm:items-center gap-2"
            >
              <span
                class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-red-100 text-red-800"
              >
                Offline
              </span>
              <span class="text-sm text-gray-600 font-medium">
                Senin, 21 September 2026
              </span>
            </div>
          </div>

          <div class="space-y-3">
            <li
              v-for="event in dayOne"
              :key="event.time"
              class="flex items-start space-x-3 text-gray-700 hover:bg-gray-50 p-2 rounded-lg transition-colors duration-200"
            >
              <div
                class="flex-shrink-0 bg-primary text-white text-xs font-semibold px-2 py-1 rounded-md min-w-[50px] text-center"
              >
                {{ event.time }}
              </div>
              <span class="flex-1 text-sm sm:text-base leading-relaxed">{{
                event.activity
              }}</span>
            </li>
          </div>
        </div>
      </div>

      <!-- Hari Kedua (Kanan) -->
      <div class="relative flex items-center">
        <!-- Dot di tengah (desktop) -->
        <div
          class="hidden md:block absolute left-1/2 w-6 h-6 bg-white border-4 border-primary rounded-full transform -translate-x-1/2 z-10 shadow-lg"
        ></div>

        <!-- Dot di kiri (mobile) -->
        <div
          class="md:hidden absolute left-[26px] w-6 h-6 bg-white border-4 border-primary rounded-full transform -translate-x-1/2 z-10 shadow-lg"
        ></div>

        <!-- Card Content -->
        <div
          class="w-full md:w-5/12 ml-12 md:ml-auto bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
          data-aos="fade-left"
          data-aos-anchor-placement="top-bottom"
          data-aos-delay="200"
        >
          <div
            class="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4 border-b border-gray-100 pb-3"
          >
            <h3 class="text-xl sm:text-2xl font-bold text-primary mb-2 sm:mb-0">
              Hari Kedua
            </h3>
            <div
              class="flex flex-col sm:flex-row items-start sm:items-center gap-2"
            >
              <span
                class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-blue-100 text-blue-800"
              >
                Online
              </span>
              <span class="text-sm text-gray-600 font-medium">
                Selasa, 22 September 2026
              </span>
            </div>
          </div>

          <div class="space-y-3">
            <li
              v-for="event in dayTwo"
              :key="event.time"
              class="flex items-start space-x-3 text-gray-700 hover:bg-gray-50 p-2 rounded-lg transition-colors duration-200"
            >
              <div
                class="flex-shrink-0 bg-primary text-white text-xs font-semibold px-2 py-1 rounded-md min-w-[50px] text-center"
              >
                {{ event.time }}
              </div>
              <span class="flex-1 text-sm sm:text-base leading-relaxed">{{
                event.activity
              }}</span>
            </li>
          </div>
        </div>
      </div>

      <!-- Hari Ketiga (Kiri) -->
      <div class="relative flex items-center">
        <!-- Dot di tengah (desktop) -->
        <div
          class="hidden md:block absolute left-1/2 w-6 h-6 bg-white border-4 border-primary rounded-full transform -translate-x-1/2 z-10 shadow-lg"
        ></div>

        <!-- Dot di kiri (mobile) -->
        <div
          class="md:hidden absolute left-[26px] w-6 h-6 bg-white border-4 border-primary rounded-full transform -translate-x-1/2 z-10 shadow-lg"
        ></div>

        <!-- Card Content -->
        <div
          class="w-full md:w-5/12 ml-12 md:ml-0 bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
          data-aos="fade-right"
          data-aos-anchor-placement="top-bottom"
          data-aos-delay="300"
        >
          <div
            class="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4 border-b border-gray-100 pb-3"
          >
            <h3 class="text-xl sm:text-2xl font-bold text-primary mb-2 sm:mb-0">
              Hari Ketiga
            </h3>
            <div
              class="flex flex-col sm:flex-row items-start sm:items-center gap-2"
            >
              <span
                class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-purple-100 text-purple-800"
              >
                Online
              </span>
              <span class="text-sm text-gray-600 font-medium">
                Rabu, 23 September 2026
              </span>
            </div>
          </div>

          <div class="space-y-3">
            <li
              v-for="event in dayThree"
              :key="event.time"
              class="flex items-start space-x-3 text-gray-700 hover:bg-gray-50 p-2 rounded-lg transition-colors duration-200"
            >
              <div
                class="flex-shrink-0 bg-primary text-white text-xs font-semibold px-2 py-1 rounded-md min-w-[50px] text-center"
              >
                {{ event.time }}
              </div>
              <span class="flex-1 text-sm sm:text-base leading-relaxed">{{
                event.activity
              }}</span>
            </li>
          </div>
        </div>
      </div>

      <!-- Hari Keempat (Kanan) -->
      <div class="relative flex items-center">
        <!-- Dot di tengah (desktop) -->
        <div
          class="hidden md:block absolute left-1/2 w-6 h-6 bg-white border-4 border-primary rounded-full transform -translate-x-1/2 z-10 shadow-lg"
        ></div>

        <!-- Dot di kiri (mobile) -->
        <div
          class="md:hidden absolute left-[26px] w-6 h-6 bg-white border-4 border-primary rounded-full transform -translate-x-1/2 z-10 shadow-lg"
        ></div>

        <!-- Card Content -->
        <div
          class="w-full md:w-5/12 ml-12 md:ml-auto bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
          data-aos="fade-left"
          data-aos-anchor-placement="top-bottom"
          data-aos-delay="400"
        >
          <div
            class="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4 border-b border-gray-100 pb-3"
          >
            <h3 class="text-xl sm:text-2xl font-bold text-primary mb-2 sm:mb-0">
              Hari Keempat
            </h3>
            <div
              class="flex flex-col sm:flex-row items-start sm:items-center gap-2"
            >
              <span
                class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-green-100 text-green-800"
              >
                Offline
              </span>
              <span class="text-sm text-gray-600 font-medium">
                Kamis, 24 September 2026
              </span>
            </div>
          </div>

          <div class="space-y-3">
            <li
              v-for="event in dayFour"
              :key="event.time"
              class="flex items-start space-x-3 text-gray-700 hover:bg-gray-50 p-2 rounded-lg transition-colors duration-200"
            >
              <div
                class="flex-shrink-0 bg-primary text-white text-xs font-semibold px-2 py-1 rounded-md min-w-[50px] text-center"
              >
                {{ event.time }}
              </div>
              <span class="flex-1 text-sm sm:text-base leading-relaxed">{{
                event.activity
              }}</span>
            </li>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";

const dayOne = [
  { time: "07.00", activity: "Berkumpul di Landmark UTDI" },
  { time: "08.00", activity: "Pembukaan PESONA 2026" },
  { time: "09.55", activity: "Materi" },
  { time: "11.40", activity: "ISHOMA" },
  { time: "12.55", activity: "Materi" },
  { time: "15.00", activity: "Pengenalan Lingkungan Kampus" },
];

const dayTwo = [
  { time: "07.15", activity: "Masuk Ruang Zoom" },
  { time: "07.45", activity: "Materi" },
  { time: "09.40", activity: "Perkenalan Dosen & Kaprodi" },
  { time: "10.10", activity: "Materi" },
  { time: "12.00", activity: "Penutupan & Penugasan" },
];

const dayThree = [
  { time: "07.15", activity: "Masuk Ruang Zoom" },
  { time: "07.45", activity: "Materi" },
  { time: "11.40", activity: "Penutupan" },
];

const dayFour = [
  { time: "07.00", activity: "Kumpul di Bale Lantip" },
  { time: "07.30", activity: "Pengenalan HIMA FTI & FMB" },
  { time: "09.15", activity: "Materi" },
  { time: "10.00", activity: "Pengenalan Ormawa & Komunitas" },
  { time: "12.30", activity: "ISHOMA" },
  { time: "13.30", activity: "Awarding & Penutupan" },
  { time: "14.00", activity: "Entertainment & Perform" },
];

// Reactive data for scroll animation
const scrollProgress = ref(0);
const timelineContainer = ref(null);

// Function to calculate scroll progress
const updateScrollProgress = () => {
  if (!timelineContainer.value) return;

  const container = timelineContainer.value;
  const containerRect = container.getBoundingClientRect();
  const containerTop = containerRect.top + window.scrollY;
  const containerHeight = container.offsetHeight;

  // Calculate scroll position relative to the timeline container
  const scrollTop = window.scrollY;
  const viewportHeight = window.innerHeight;

  // More responsive calculation - start earlier and end later for smoother experience
  const startPoint = containerTop - viewportHeight * 0.8;
  const endPoint = containerTop + containerHeight - viewportHeight * 0.2;

  if (scrollTop < startPoint) {
    scrollProgress.value = 0;
  } else if (scrollTop > endPoint) {
    scrollProgress.value = 100;
  } else {
    // Calculate progress between 0 and 100 with more responsive mapping
    const progress = ((scrollTop - startPoint) / (endPoint - startPoint)) * 100;
    scrollProgress.value = Math.min(Math.max(progress, 0), 100);
  }
};

// More frequent updates for smoother animation
const throttledUpdateScrollProgress = () => {
  updateScrollProgress();
};

// Lifecycle hooks
onMounted(() => {
  window.addEventListener("scroll", throttledUpdateScrollProgress);
  updateScrollProgress(); // Initial calculation
});

onUnmounted(() => {
  window.removeEventListener("scroll", throttledUpdateScrollProgress);
});
</script>
